<template>
  <b-card>
    <template v-slot:header>
      <span class="breadcrumbs"><b-link :to="{name: `project`}">Videos</b-link> / Create</span>
    </template>

    <b-form @submit.stop.prevent="create_item">
      <b-form-group label="Name:" invalid-feedback="Must be greater then 4 character">
        <b-form-input v-model="item.name" placeholder="Enter name"></b-form-input>
      </b-form-group>

      <b-form-group label="Script:" v-if="!variables || variables.length == 0">
        <b-form-input v-model="item.script" placeholder="Hey John! I'm Jane from Vidon. Let's catch up soon" class="mb-2"></b-form-input>
      </b-form-group>

      <b-form-group label="Website:" v-if="project.presentation === 'website'">
        <b-form-input v-model="item.website" type="url" placeholder="https://example.com" class="mb-2"></b-form-input>
      </b-form-group>

      <b-table-simple responsive bordered v-if="variables && variables.length > 0">
        <b-thead head-variant="light">
          <b-tr>
            <b-th>Variable</b-th>
            <b-th>Replace with</b-th>
          </b-tr>
        </b-thead>
        <b-tr v-for="(variable, index) in variables" v-bind:key="index">
          <b-td>{{variable.word}}</b-td>
          <b-td><b-form-input v-model="variable.replace_with" size="sm" :disabled="!variable.word" placeholder="John"></b-form-input></b-td>
        </b-tr>
      </b-table-simple>

      <LoadingButton type="submit" variant='primary' :loading="is_saving">Save</LoadingButton>
    </b-form>

  </b-card>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators"
import ItemMixin from "@/mixins/Item.js"
import ConstantsMixin from "@/mixins/Constants.js"
import { db, FieldValue, config } from '@/main.js'
import moment from 'moment/src/moment'

export default {
  metaInfo: {title: 'Item create'},
  mixins: [ItemMixin, ConstantsMixin],
  props: ['project', 'profile'],
  validations: {
    item: {
      // name: {required, minLength: minLength(3)},
    }
  },
  firestore: function () {
    return {
      _item: db.collection('project').doc(this.$route.params.id).collection(this.collection).doc(this.item_id)
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'item') {
      next()
      return
    }

    const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
    if (answer) {
      next()
    } else {
      next(false)
    }
  },
  data() {
    console.log(this.project)
    let variables = []
    for (let variable of this.project.variables) {
      variables.push({word: variable['word'], replace_with: null})
    }

    let item_id = db.collection('random').doc().id

    return {
      item_id: item_id,
      param: 'item',
      collection: 'item',
      variables: variables,
      item: {
        name: '',
        status: 'pending', // TODO
        variables: variables,
        video_url: null,
        error_message: null,
        video_player_url: `https://${config.firebase_config.video_domain}/video/?project=${encodeURIComponent(this.project.id)}&item=${encodeURIComponent(item_id)}`,
        thumbnail_url: null,
        overlay_text: null,
        rerendered: false,
        played: 0,
        visited: 0,
        finished: 0,
        clicked: 0,
      },
    }
  },
  // watch: {
  //   'variables': {
  //     deep: true,
  //     handler: function(val) {
  //
  //       let last_item = val[val.length-1]
  //       console.log(last_item)
  //       if (last_item.word !== null && last_item.replace_with !== null) {
  //         this.variables.push({word: null, replace_with: null})
  //       }
  //     }
  //   }
  // },
  methods: {
    do_before() {
      let final = []
      let first_name = null
      for (let variable of this.variables) {
        if (variable.word == 'name') {
          this.item.overlay_text = `Hey ${variable.replace_with}`
          first_name = variable.replace_with
        }

        if (!variable.word && !variable.replace_with) {
          continue
        } else if (!variable.word || !variable.replace_with) {
          this.$swal({title: 'Incomple replacement', text: "Please complete all variable replacements", icon: 'warning'})
          return false
        } else {
          final.push(variable)
        }
      }

      if (!this.item.name) {
        this.item.name = first_name || moment().format('HH:MM DD/MM/YY')
      }

      this.item.variables = final
    },
    async do_after() {
      let update = {updated: new Date()}
      update[`usage.${this.profile.id}.recipients`] = FieldValue.increment(1)
      await db.collection('team').doc(this.profile.team.id).collection('period').doc(this.profile.team.current_period.id).update(update)

      await db.collection('project').doc(this.$route.params.id).update({updated: new Date(), items_count: FieldValue.increment(1)})
    }
  }
}
</script>

<style>

</style>
